import {
  disputeAlertStatus,
  disputeAlertType,
} from "@redotech/redo-dispute-db-schema/dispute-alert-definition";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

// Total count matching the same filters as getReclaimAlerts. Split out so the
// count is fetched independently and cached longer than the page query.
export const getReclaimAlertsCount = unaryRpc({
  name: "getReclaimAlertsCount" as const,
  input: z.object({
    statuses: z.array(z.enum(disputeAlertStatus)).optional(),
    types: z.array(z.enum(disputeAlertType)).optional(),
  }),
  output: z.object({ total: z.number().int() }),
});
